/* eslint-disable no-restricted-imports */
import { ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { ROCKET_POOL_ERC20 } from '../constants';
export var Withdraw = createPlugin({
    protocol: 'ROCKETPOOL',
    type: 'ACTION',
    method: 'burn',
    name: 'unstake',
    supportedContracts: ROCKET_POOL_ERC20,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                amount: new FctValue18({}),
            },
        },
        output: {},
    }); },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, amount = params.methodParams.amount;
        if (!to.value || !amount.value || !vaultAddress)
            return [];
        if (typeof to.value !== 'string' || typeof amount.value !== 'string')
            return [];
        // TODO: cToken amount needs to be calculated off chain.
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: to.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [
                    {
                        token: ethers.constants.AddressZero,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
